import { INITIALIZE_SETTINGS_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_SETTINGS_FORM](values);
